export enum ResourceType {
  BlogArticle,
  Cat, // Meow
  Ebook,
  Interact,
  Navigator,
  Pdf,
  PrintBook,
  StudentCenter,
  Website,
  QuestionBank,
  Video,
  Exam,
  LsacPreptest,
  Unknown
}



// WEBPACK FOOTER //
// ./src/app/shared/models/resource-type.ts